'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var flattenOptions = function (options) {
    if (options === void 0) { options = []; }
    var flattened = [];
    options.forEach(function (option) {
        if (option.options) {
            option.options.forEach(function (opt) {
                flattened.push(opt);
            });
        }
        else {
            flattened.push(option);
        }
    });
    return flattened;
};

exports.flattenOptions = flattenOptions;
//# sourceMappingURL=utils.js.map
